/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { globals as globalsSlice } from '../../app/globalsSlice';
import EUIPNLogo from '../../assets/images/logo_euipn.svg';
import logorepublica from '../../assets/images/logo_republica.svg';
import logojustica from '../../assets/images/logojustica.svg';
import { t } from '../../providers/TranslationProvider';
import ExternalLinks from '../ExternalLinks';

const useStyles = makeStyles((theme) => ({
    footer: {
        backgroundColor: theme.palette.action.footerGrey,
        height: '170px',
        padding: '16px 48px 0px 48px',
    },
    footerLinkLg: {
        color: '#ffffff',
        fontSize: '0.875rem',
        fontWeight: 'normal',
        paddingBottom: '5px',
        cursor: 'pointer',
        marginRight: '50px',
        textDecoration: 'none',
        '@media (max-width:280px)': {
            fontSize: '0.6875rem',
        },
        '&:hover': {
            color: '#BDE298',
            textDecoration: 'underline',
        },
    },
    footerInner: {
        padding: '16px 48px 24px 48px', //'30px 60px',
        color: '#466CB4',
        fontSize: '0.75rem',
        width: '100%',
        margin: 'unset',
    },
    info: {
        color: '#ffffff',
        marginRight: '40px',
    },
    infoItem: {
        lineHeight: '20px',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '0.875rem',
        letterSpacing: 'normal',
        color: '#ffffff',
    },
    footerversion: {
        float: 'right',
        fontSize: '0.75rem',
        opacity: '.5',
    },
    informationLinksCol: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },
    section: {
        marginTop: '0px',
        display: 'flex',
    },
    sectionHalf: {
        height: '75%',
    },
    logo: {
        display: 'inline-block',
        '&:focus-visible': {
            border: '2px dashed white ',
            outline: 'none ',
            padding: '4px',
        },
    },
    social: {
        display: 'flex',
        alignItems: 'center',
    },
    socialBtn: {
        paddingRight: '20px',
    },
    appVersionSection: {
        height: '100%',
        padding: '30px 60px 30px 0',
    },
    appVersion: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '0px !important',
    },
    footerLinks: {
        paddingLeft: '60px',
        textAlign: 'center',
        '@media (max-width:600px)': {
            paddingLeft: '45px',
        },
        '@media (max-width:320px)': {
            paddingLeft: '12px',
        },
        '@media (max-width:280px)': {
            paddingLeft: '10px',
        },
    },
}));

// const useStylesFooterTitle = makeStyles((theme) => ({
//     title: {
//         color: theme.palette.primary.main,
//         fontWeight: theme.typography.titleFontWeight,
//         fontSize: theme.typography.titleFontSize,
//         borderBottom: '3px solid' + theme.palette.text.outlined,
//         paddingBottom: '15px',
//     },
// }));

// const FooterTitle = ({ title }) => {
//     const classes = useStylesFooterTitle();
//     return <Typography className={classes.title}>{title}</Typography>;
// };

const Footer = () => {
    const classes = useStyles();
    const { globals } = useSelector(globalsSlice) || {};

    const footerExternalLinks = globals && globals.footer && Object.values(globals.footer);

    const d = new Date();
    const year = d.getFullYear();

    return (
        <div className={classes.footer}>
            <Grid container>
                <Grid item xs={4} style={{ height: '106px' }}>
                    <a
                        className={classes.logo}
                        style={{ marginTop: '23.19px' }}
                        href={globals.ipo['euipo.image.url']}
                        target={'_blank'}
                        rel="noopener noreferrer"
                        title={t('open.new.tab')}>
                        <img src={EUIPNLogo} alt={t('footer.euipn.logo')} />
                    </a>
                </Grid>
                <Grid item xs={4} style={{ textAlign: 'center', height: '106px' }}>
                    <a
                        className={classes.logo}
                        style={{ marginTop: '29.5px' }}
                        href={globals.ipo['justica.gov.image.url']}
                        target={'_blank'}
                        rel="noopener noreferrer"
                        title={t('open.new.tab')}>
                        <img src={logojustica} alt={t('footer.justice.logo')} />
                    </a>
                </Grid>
                <Grid item xs={4} style={{ textAlign: 'right', height: '106px' }}>
                    <a
                        className={classes.logo}
                        href={globals.ipo['republica.portuguesa.image.url']}
                        target={'_blank'}
                        rel="noopener noreferrer"
                        title={t('open.new.tab')}>
                        <img src={logorepublica} alt={t('footer.republic.logo')} />
                    </a>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} className={classes.footerLinks}>
                    <ExternalLinks links={footerExternalLinks} className={`${classes.footerLinkLg} ${classes.logo}`} />
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs style={{ textAlign: 'center' }}>
                    <Typography variant={'subtitle2'} className={`${classes.infoItem} ${classes.logo}`} component={'div'}>
                        {year} | Instituto Nacional da Propriedade Industrial
                    </Typography>
                </Grid>
            </Grid>
        </div>
    );
};

export default Footer;
